/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * PanLuma API
 * Enterprise productivity application API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type { HTTPValidationError } from '../models/hTTPValidationError';

import type { ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest } from '../models/modulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest';

import type { ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest } from '../models/modulesMasterDataProductsApiSettingsRoutesUserSettingsRequest';

import type { ProductCapabilities } from '../models/productCapabilities';

import type { SysadminSettingsRequest } from '../models/sysadminSettingsRequest';

import { customInstance } from '../../../shared/api/axiosInstance';

/**
 * Get current user's products settings.
 * @summary Get User Settings
 */
export const getUserSettingsApiV1MasterDataProductsSettingsUserGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/settings/user`,
    method: 'GET',
    signal
  });
};

export const getGetUserSettingsApiV1MasterDataProductsSettingsUserGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/settings/user`] as const;
  };

export const getGetUserSettingsApiV1MasterDataProductsSettingsUserGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetUserSettingsApiV1MasterDataProductsSettingsUserGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
      >
    > = ({ signal }) =>
      getUserSettingsApiV1MasterDataProductsSettingsUserGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetUserSettingsApiV1MasterDataProductsSettingsUserGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
    >
  >;
export type GetUserSettingsApiV1MasterDataProductsSettingsUserGetQueryError =
  unknown;

export function useGetUserSettingsApiV1MasterDataProductsSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetUserSettingsApiV1MasterDataProductsSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetUserSettingsApiV1MasterDataProductsSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get User Settings
 */

export function useGetUserSettingsApiV1MasterDataProductsSettingsUserGet<
  TData = Awaited<
    ReturnType<typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getUserSettingsApiV1MasterDataProductsSettingsUserGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetUserSettingsApiV1MasterDataProductsSettingsUserGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update current user's products settings.
 * @summary Update User Settings
 */
export const updateUserSettingsApiV1MasterDataProductsSettingsUserPut = (
  modulesMasterDataProductsApiSettingsRoutesUserSettingsRequest: ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/settings/user`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesMasterDataProductsApiSettingsRoutesUserSettingsRequest
  });
};

export const getUpdateUserSettingsApiV1MasterDataProductsSettingsUserPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateUserSettingsApiV1MasterDataProductsSettingsUserPut
        >
      >,
      TError,
      { data: ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateUserSettingsApiV1MasterDataProductsSettingsUserPut
      >
    >,
    TError,
    { data: ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateUserSettingsApiV1MasterDataProductsSettingsUserPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateUserSettingsApiV1MasterDataProductsSettingsUserPut
        >
      >,
      { data: ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateUserSettingsApiV1MasterDataProductsSettingsUserPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateUserSettingsApiV1MasterDataProductsSettingsUserPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateUserSettingsApiV1MasterDataProductsSettingsUserPut
      >
    >
  >;
export type UpdateUserSettingsApiV1MasterDataProductsSettingsUserPutMutationBody =
  ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest;
export type UpdateUserSettingsApiV1MasterDataProductsSettingsUserPutMutationError =
  HTTPValidationError;

/**
 * @summary Update User Settings
 */
export const useUpdateUserSettingsApiV1MasterDataProductsSettingsUserPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateUserSettingsApiV1MasterDataProductsSettingsUserPut
        >
      >,
      TError,
      { data: ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<typeof updateUserSettingsApiV1MasterDataProductsSettingsUserPut>
  >,
  TError,
  { data: ModulesMasterDataProductsApiSettingsRoutesUserSettingsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateUserSettingsApiV1MasterDataProductsSettingsUserPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get tenant's products settings. Requires module admin.
 * @summary Get Tenant Settings
 */
export const getTenantSettingsApiV1MasterDataProductsSettingsTenantGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/settings/tenant`,
    method: 'GET',
    signal
  });
};

export const getGetTenantSettingsApiV1MasterDataProductsSettingsTenantGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/settings/tenant`] as const;
  };

export const getGetTenantSettingsApiV1MasterDataProductsSettingsTenantGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetTenantSettingsApiV1MasterDataProductsSettingsTenantGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
        >
      >
    > = ({ signal }) =>
      getTenantSettingsApiV1MasterDataProductsSettingsTenantGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetTenantSettingsApiV1MasterDataProductsSettingsTenantGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
      >
    >
  >;
export type GetTenantSettingsApiV1MasterDataProductsSettingsTenantGetQueryError =
  unknown;

export function useGetTenantSettingsApiV1MasterDataProductsSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet>
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetTenantSettingsApiV1MasterDataProductsSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetTenantSettingsApiV1MasterDataProductsSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Tenant Settings
 */

export function useGetTenantSettingsApiV1MasterDataProductsSettingsTenantGet<
  TData = Awaited<
    ReturnType<typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet>
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getTenantSettingsApiV1MasterDataProductsSettingsTenantGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetTenantSettingsApiV1MasterDataProductsSettingsTenantGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update tenant's products settings. Requires module admin.
 * @summary Update Tenant Settings
 */
export const updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut = (
  modulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest: ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/settings/tenant`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: modulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest
  });
};

export const getUpdateTenantSettingsApiV1MasterDataProductsSettingsTenantPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut
        >
      >,
      TError,
      { data: ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut
      >
    >,
    TError,
    { data: ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut
        >
      >,
      { data: ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut(data);
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateTenantSettingsApiV1MasterDataProductsSettingsTenantPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut
      >
    >
  >;
export type UpdateTenantSettingsApiV1MasterDataProductsSettingsTenantPutMutationBody =
  ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest;
export type UpdateTenantSettingsApiV1MasterDataProductsSettingsTenantPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Tenant Settings
 */
export const useUpdateTenantSettingsApiV1MasterDataProductsSettingsTenantPut = <
  TError = HTTPValidationError,
  TContext = unknown
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut
        >
      >,
      TError,
      { data: ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<
    ReturnType<
      typeof updateTenantSettingsApiV1MasterDataProductsSettingsTenantPut
    >
  >,
  TError,
  { data: ModulesMasterDataProductsApiSettingsRoutesTenantSettingsRequest },
  TContext
> => {
  const mutationOptions =
    getUpdateTenantSettingsApiV1MasterDataProductsSettingsTenantPutMutationOptions(
      options
    );

  return useMutation(mutationOptions, queryClient);
};
/**
 * Get sysadmin products settings. Requires sysadmin.
 * @summary Get Sysadmin Settings
 */
export const getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet = (
  signal?: AbortSignal
) => {
  return customInstance<unknown>({
    url: `/api/v1/master-data/products/settings/sysadmin`,
    method: 'GET',
    signal
  });
};

export const getGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/settings/sysadmin`] as const;
  };

export const getGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
        >
      >
    > = ({ signal }) =>
      getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet(signal);

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
      >
    >
  >;
export type GetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGetQueryError =
  unknown;

export function useGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet<
  TData = Awaited<
    ReturnType<
      typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet<
  TData = Awaited<
    ReturnType<
      typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet<
  TData = Awaited<
    ReturnType<
      typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Sysadmin Settings
 */

export function useGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet<
  TData = Awaited<
    ReturnType<
      typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getSysadminSettingsApiV1MasterDataProductsSettingsSysadminGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetSysadminSettingsApiV1MasterDataProductsSettingsSysadminGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update sysadmin products settings. Requires sysadmin.
 * @summary Update Sysadmin Settings
 */
export const updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut =
  (sysadminSettingsRequest: SysadminSettingsRequest) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/settings/sysadmin`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: sysadminSettingsRequest
    });
  };

export const getUpdateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPutMutationOptions =
  <TError = HTTPValidationError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<
          typeof updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut
        >
      >,
      TError,
      { data: SysadminSettingsRequest },
      TContext
    >;
  }): UseMutationOptions<
    Awaited<
      ReturnType<
        typeof updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut
      >
    >,
    TError,
    { data: SysadminSettingsRequest },
    TContext
  > => {
    const mutationKey = [
      'updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut'
    ];
    const { mutation: mutationOptions } = options
      ? options.mutation &&
        'mutationKey' in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey } };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<
          typeof updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut
        >
      >,
      { data: SysadminSettingsRequest }
    > = (props) => {
      const { data } = props ?? {};

      return updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut(
        data
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type UpdateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPutMutationResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut
      >
    >
  >;
export type UpdateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPutMutationBody =
  SysadminSettingsRequest;
export type UpdateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPutMutationError =
  HTTPValidationError;

/**
 * @summary Update Sysadmin Settings
 */
export const useUpdateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut =
  <TError = HTTPValidationError, TContext = unknown>(
    options?: {
      mutation?: UseMutationOptions<
        Awaited<
          ReturnType<
            typeof updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut
          >
        >,
        TError,
        { data: SysadminSettingsRequest },
        TContext
      >;
    },
    queryClient?: QueryClient
  ): UseMutationResult<
    Awaited<
      ReturnType<
        typeof updateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPut
      >
    >,
    TError,
    { data: SysadminSettingsRequest },
    TContext
  > => {
    const mutationOptions =
      getUpdateSysadminSettingsApiV1MasterDataProductsSettingsSysadminPutMutationOptions(
        options
      );

    return useMutation(mutationOptions, queryClient);
  };
/**
 * Effective catalog capabilities for the current member. Read-only.

Why this route exists: the tenant and sysadmin settings GETs above are
``require_module_admin("products")`` / ``require_sysadmin`` and STAY that
way, but six member-open products surfaces need a handful of the facts
behind them — the picker rendered per line item across sales and
procurement, the quick-create dialog, the product and category detail
pages, the module dashboard and the variants tab. Reading the admin route
from those surfaces 403s for every non-admin and the pages render the
failure as a feature flag read as FALSE
(`.claude/rules/rules-frontend.md` § "A page open to ordinary members never
reads from an ADMIN-gated route"). So the payload is SERVED, narrowed to
what a reader needs, rather than the admin configuration model being
re-exposed.

Auth is bare ``require_auth``, matching the module: every one of the 97
member reads on the products router gates the same way, and
``require_module_access`` is used nowhere in ``master_data``. There is
nothing narrower to gate on either — a member who can open a quote line can
already list the catalog, and these are the tenant's own capability facts,
carrying no per-record data.

``max_variants_per_product`` is a limit, not a configuration surface: it is
served as the EFFECTIVE resolved value through the settings service's own
user -> tenant -> sysadmin inheritance, never by exposing the sysadmin row.
 * @summary Get Product Capabilities
 */
export const getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet =
  (signal?: AbortSignal) => {
    return customInstance<ProductCapabilities>({
      url: `/api/v1/master-data/products/settings/capabilities`,
      method: 'GET',
      signal
    });
  };

export const getGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/settings/capabilities`] as const;
  };

export const getGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
        >
      >
    > = ({ signal }) =>
      getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
      >
    >
  >;
export type GetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGetQueryError =
  unknown;

export function useGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet<
  TData = Awaited<
    ReturnType<
      typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet<
  TData = Awaited<
    ReturnType<
      typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet<
  TData = Awaited<
    ReturnType<
      typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Product Capabilities
 */

export function useGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet<
  TData = Awaited<
    ReturnType<
      typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetProductCapabilitiesApiV1MasterDataProductsSettingsCapabilitiesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get enabled product types.
 * @summary Get Enabled Product Types
 */
export const getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/settings/product-types`,
      method: 'GET',
      signal
    });
  };

export const getGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/settings/product-types`] as const;
  };

export const getGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
        >
      >
    > = ({ signal }) =>
      getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
      >
    >
  >;
export type GetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGetQueryError =
  unknown;

export function useGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Enabled Product Types
 */

export function useGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEnabledProductTypesApiV1MasterDataProductsSettingsProductTypesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get enabled billing cycles.
 * @summary Get Enabled Billing Cycles
 */
export const getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet =
  (signal?: AbortSignal) => {
    return customInstance<unknown>({
      url: `/api/v1/master-data/products/settings/billing-cycles`,
      method: 'GET',
      signal
    });
  };

export const getGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGetQueryKey =
  () => {
    return [`/api/v1/master-data/products/settings/billing-cycles`] as const;
  };

export const getGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGetQueryOptions =
  <
    TData = Awaited<
      ReturnType<
        typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
      >
    >,
    TError = unknown
  >(options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
          >
        >,
        TError,
        TData
      >
    >;
  }) => {
    const { query: queryOptions } = options ?? {};

    const queryKey =
      queryOptions?.queryKey ??
      getGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGetQueryKey();

    const queryFn: QueryFunction<
      Awaited<
        ReturnType<
          typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
        >
      >
    > = ({ signal }) =>
      getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet(
        signal
      );

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
      Awaited<
        ReturnType<
          typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
        >
      >,
      TError,
      TData
    > & { queryKey: DataTag<QueryKey, TData> };
  };

export type GetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGetQueryResult =
  NonNullable<
    Awaited<
      ReturnType<
        typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
      >
    >
  >;
export type GetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGetQueryError =
  unknown;

export function useGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
    >
  >,
  TError = unknown
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
          >
        >,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<
            ReturnType<
              typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
            >
          >,
          TError,
          Awaited<
            ReturnType<
              typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
            >
          >
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Enabled Billing Cycles
 */

export function useGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet<
  TData = Awaited<
    ReturnType<
      typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
    >
  >,
  TError = unknown
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<
          ReturnType<
            typeof getEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGet
          >
        >,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions =
    getGetEnabledBillingCyclesApiV1MasterDataProductsSettingsBillingCyclesGetQueryOptions(
      options
    );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
